export enum Instrument {
  None = 'None',
  DrumAC = 'DrumAC',
  DrumElec = 'DrumElec',
  DrumLofiA = 'DrumLofiA',
  DrumLofiB = 'DrumLofiB',
}
